
  export const style={
    inpuStyle:{
      colorInput:"#87B0B4"
    },
    url:{
      urlClient:"https://bein.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.amazonaws.com/Logos/logotipo_primary_bein.png"
    },
    CurrencyName:{
      name:"Ponto/Pontos"
    },
    teamName:{
      name:"Bein"
    },
    hasToken: false,
    hostHeader: "bein"
  }
